<template>
    <div class="card_body">
        <van-row >
            <van-col span="12" class="card_content">
                <van-row class="fieldRow ">
                    <van-col class="field_row" span="24">{{ props.title1 }}</van-col>
                    <van-col class="field_row_value" span="24">
                        <span>{{ props.value1 }}</span>
                        <div v-if="props.rightText2">{{ props.rightText2 }}</div>
                    </van-col>
                </van-row>
            </van-col>

            <van-col span="12" class="card_content">
                <van-row class="fieldRow">
                    <van-col class="field_row" span="24">{{ props.title2 }}</van-col>
                    <van-col class="field_row_value" span="24">
                        <span>{{ props.value2 }}</span>
                        <div v-if="props.rightText2">{{ props.rightText2 }}</div>
                    </van-col>
                </van-row>
            </van-col>
        </van-row>
    </div>
</template>

<script setup lang="ts">
const props = defineProps({
    title1: {
        type: String,
        default: () => ''
    },
    title2: {
        type: String,
        default: () => ''
    },
    title3: {
        type: String,
        default: () => ''
    },
    value1: {
        type: [String, Number],
        default: () => 0
    },
    value2: {
        type: [String, Number],
        default: () => 0
    },
    value3: {
        type: [String, Number],
        default: () => 0
    },
    rightText1: {
        type: String,
        default: () => ''
    },
    rightText2: {
        type: String,
        default: () => ''
    },
})

</script>
<style scoped>
.card_body {
    overflow: hidden;
    font-size: 15px;
    position: relative;
    margin: 5px 0;
}

.card_body img {
    width: 100%;
}

.card_body img {
    width: 100%;
}

.card_content {
    padding: 2.5px;
}

.field_row {
    padding: 5px;
    color: rgba(255, 255, 255, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.total_row {
    padding: 18px 15px;
    color: rgba(255, 255, 255, 0.85);
    font-weight: bold;
}

.field_row_value {
    color: #fff;
    display: flex;
    font-size: 13px;
    justify-content: center;
    align-items: center;
}

.field_row_value span {
    padding: 0 5px;
    color: rgba(255, 255, 255, 0.5);
    font-size: 25px;
}

.fieldRow {
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgb(0, 86, 85);
    padding: 10px;
    border-radius: 10px;
}

.totalRow {
    background: #ffffff38;

}
</style>